// Slide to the relevant menu collection
document.querySelectorAll(".promotion-slider .card-list").forEach((link) => {
  link.addEventListener("click", function (event) {
    event.preventDefault();
    const targetTitle = this.getAttribute("title");
    const targetBlock = document.getElementById(targetTitle);

    if (targetBlock) {
      targetBlock.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  });
});

// PDF Block
const cards = document.getElementsByClassName("card");
const popdetails = document.querySelectorAll(".pop-details");

for (let i = 0; i < cards.length; i++) {
  cards[i].addEventListener("click", function () {
    popdetails.forEach(p => p.style.display = "none");
    popdetails[i].style.display = "flex";    
  });
}

// Close popup when clicking on close button
document.querySelectorAll(".closePop").forEach(btn => {
  btn.addEventListener("click", function () {
    this.closest(".pop-details").style.display = "none";
  });
});
